import { Box, Typography } from '@mui/material';
import { useShowContext } from 'framework/show';

const WelcomeSection = () => {
  const { data } = useShowContext();
  const firstName = data?.getValueBySource?.('nameEn.firstName') || data?.getValueBySource?.('firstName') || '';
  const lastName = data?.getValueBySource?.('nameEn.lastName') || data?.getValueBySource?.('lastName') || '';
  const fullName = firstName && lastName ? `${firstName} ${lastName}` : 'User';

  return (
    <Box m={1} p={2} bgcolor="background.paper" borderRadius={1}>
      <Typography variant="h3" color="brand" pl={3}>
        Welcome, {fullName}!
      </Typography>
    </Box>
  );
};

export default WelcomeSection;
